export const getStyles = ({ awardText }) => ({
	couponDescription: {
		wrapper:
			"tw:bg-[#faf2fd] tw:mt-4 tw:relative tw:flex tw:items-center tw:justify-center tw:p-2 tw:border tw:border-dashed tw:border-[#616096] tw:rounded-lg tw:lg:p-2 tw:desktop:w-full tw:desktop:max-w-[190px]",
		icon: {
			wrapper:
				"tw:absolute tw:top-[-8px] tw:lg:top-[-11px] tw:right-5 tw:flex tw:items-center tw:justify-center tw:px-2 tw:lg:px-1.5",
			content: "tw:text-[#616096] tw:w-[15px] tw:h-[15px] tw:lg:w-5 tw:lg:h-5",
		},
		content:
			"tw:lg2:min-w-[144px] tw:leading-6 tw:font-semibold tw:text-sm tw:text-center tw:text-[#616096] tw:lg:text-base tw:lg:tracking-[-0.01rem]",
	},
	serviceFlag: {
		wrapper: `tw:relative tw:flex ${awardText ? "tw:pb-8" : "tw:items-center"}`,
		flag: `tw:absolute ${awardText ? "tw:top-0 tw:desktop:top-[40%]" : "tw:top-[50%] tw:desktop:top-auto"} tw:w-8 tw:h-8 tw:bg-[#616096] tw:shadow-[1px_3px_3px_lightgrey] tw:flex tw:items-center tw:justify-center tw:rounded-full`,
		number:
			"tw:text-white tw:text-sm tw:font-medium tw:m-0 tw:leading-none pb-0.5",
		text: `tw:desktop:left-0 tw:left-10 tw:rounded-md tw:pl-3 tw:absolute tw:w-max tw:leading-4 tw:h-8 tw:text-white tw:flex tw:items-center tw:justify-center tw:bg-[#e1255b] tw:text-base tw:font-semibold tw:shadow-[1px_3px_3px_lightgrey] tw:after:relative tw:after:left-[6px] tw:after:w-[22px] tw:after:inset-0 tw:after:[border-right:13px_solid_white] tw:after:[border-top:16px_solid_#e1255b] tw:after:[border-bottom:16px_solid_#e1255b]`,
	},
	companyLogo: {
		picture: "tw:max-w-[300px] tw:text-center",
		image: "tw:max-w-[60%] tw:desktop:max-w-[160px]",
	},
	trustpilotReview: {
		container:
			"tw:flex tw:flex-col tw:w-fit tw:text-center tw:min-w-[118px] tw:max-w-[120px]",
		reviewCount:
			"tw:text-[#232227] tw:font-semibold tw:text-[13px] tw:leading-normal",
		reviewCountNumber: "tw:font-extrabold tw:font-montserrat",
		reviewCountText: "tw:font-normal",
		ratingContainer: "tw:my-1 tw:flex tw:gap-[3px] tw:justify-center",
		starBase:
			"tw:relative tw:rounded-[3px] tw:w-[18px] tw:h-[18px] tw:flex tw:items-center tw:justify-center tw:text-white tw:text-xs",
		ratingCountWrapper: "tw:w-full tw:flex tw:items-center tw:justify-evenly",
		ratingCount: "tw:font-extrabold tw:mr-0.5 tw:text-base tw:text-[#232227]",
		ratingCountText: "tw:text-base tw:text-[#232227]",
		trustPilotLogo: "tw:h-4 tw:w-auto",
	},
	rating: {
		wrapper:
			"tw:flex tw:items-center tw:gap-1.5 tw:bg-white tw:px-3 tw:py-2 tw:xs:px-5 tw:xs:py-3 tw:xs:gap-2",
		score:
			"tw:text-[28px] tw:font-bold tw:leading-[22px] tw:text-[#14a82a] tw:m-0",
		stars: "tw:flex tw:flex-col tw:gap-2",
		starColor: "tw:text-[#faaf00]",
		starSize: "tw:text-[13px] tw:xs:text-[15px]",
		count:
			"tw:ml-0.5 tw:text-xs tw:font-semibold tw:leading-3 tw:text-[#333742] tw:mr-0 tw:my-0 tw:xs:text-xs tw:xs:leading-3",
	},
	columnInformation: {
		wrapper:
			"tw:grid tw:w-full tw:items-center tw:desktop:w-[240px] tw:lg2:w-[286px]",
		columnWrapper: "tw:flex tw:flex-col tw:justify-center tw:text-center",
		column: "",
		label:
			"tw:desktop:hidden tw:pb-1.5 tw:font-montserrat tw:text-[11px] tw:text-[#787e81] tw:uppercase tw:font-semibold tw:tracking-wider tw:leading-normal",
		value:
			"tw:text-pretty tw:text-[13px] tw:desktop:text-base tw:font-semibold tw:text-[#232227]",
	},
	benefitsList: {
		wrapper: "",
		list: `tw:flex tw:flex-col tw:max-w-[340px] tw:desktop:min-w-[320px] tw:desktop:max-w-[330px] tw:lg2:min-w-[340px]`,
		listItem: `tw:mb-1.5 tw:pl-5 tw:text-[#1a202c] tw:text-sm tw:desktop:text-base tw:font-normal tw:leading-6 tw:bg-[url(/public/react-images/common/favyCheck.svg)] tw:bg-position-[left_top_8px] tw:bg-no-repeat`,
		expandButton:
			"tw:mt-[5px] tw:w-full tw:flex tw:cursor-pointer tw:items-center tw:border-0 tw:bg-transparent tw:py-0 tw:pl-5 tw:text-[#48484b]",
		expandBenefitsContent: "tw:text-[13px]",
		expandButtonIcon: "tw:ml-1 tw:text-lg tw:rotate-90",
	},
	reviewLink: {
		wrapper:
			"tw:text-center tw:table tw:text-[#2f855a] tw:text-sm tw:font-semibold tw:leading-4 tw:mt-4 tw:mx-auto ",
		text: "",
	},
});
